import Betelgeuse from 'js/betelgeuse';
import $ from 'jquery';
import _ from 'underscore';
require('js/boot');
require('../css/site.less');
require('js/helpscoutBeacon');
require('../css/components/cookieControlModule.scss');
require('../css/vendor/addToHomeScreen.scss');
require('js/vendor/addToHomeScreen');

// Create a betelgeuse instance
var app = window.app = new Betelgeuse({

  // Define our app routes
  routes: {
    'follow/community/:id/:name(/*navigate)': 'community.follow', // used in featured posts
    // 'follow/post/:id/:name(/*navigate)': 'community.followPost',

    // Context admin
    ':context/settings(/:action)(/)': 'admin:$context.$action',

    // Fake catch all which will error down the chain and show a 404
    '*catchAllFakeRoute': 'catchAll:fake.route',
  },

});

// Before any routing occurs let's remove any weird hash stuff as it will interfere with routing (Eg. facebook)
if (location.hash.indexOf('#_=_') > -1) {
  location.hash = '';
}

// Start up our application
app.start();

if (window.addToHomescreen) {
  window.addToHomescreen({
    skipFirstVisit: true, // show only to returning visitors
    startDelay: 2, // display the message after that many seconds from page load
    maxDisplayCount: 1, // maximum number of times the message will be shown to the user
  });
}

$(document).on('click', 'a:not([data-bypass])', (event) => {
  // As we assume the control of 'default action' we don t want to do anything
  // if we have explicitly said not to.
  // OR
  // If 'meta' key is pressed (Ie. command on a mac) or ctrl key
  if (event.isDefaultPrevented() || event.metaKey || event.ctrlKey) {
    return;
  }

  // Get the absolute anchor href.
  var href = $(this).attr('href');

  if (_.isEmpty(href)) {
    return;
  }

  // If the href exists and is a hash route, run it through Backbone.
  if (href.indexOf('://') === -1 && href.indexOf('javascript:') !== 0) {
    // Stop the default event to ensure the link will not cause a page refresh.
    event.preventDefault();

    // We don't want anything to catch this click above (we're definitely navigating elsewhere now) so prevent bubbling
    event.stopPropagation();

    app.router.navigate(href);
  }
});

module.exports = app;



// WEBPACK FOOTER //
// ./app/assets/js/main.js